<template>
    <modal :show.sync="showModal"
    >
        <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <div class="row justify-content-center text-center mb-lg">
                    <div class="col-lg-12">
                        <h2 class="display-4">Cambiar foto de perfil</h2>
                    </div>
                </div>
            <template>
            
                <form role="form">
                    <div class="row">
                        <small class="d-block text-uppercase font-weight-bold mb-3">Carga la foto:</small>
                        <div class="form-group input-group">
                            <image-uploader
                                :debug="1"
                                :maxWidth="512"
                                :quality="0.7"
                                :autoRotate=true
                                outputFormat="verbose"
                                :preview=false
                                :className="['fileinput', { 'fileinput--loaded' : hasImage }]"
                                :capture="false"
                                accept="video/*,image/*"
                                doNotResize="['gif', 'svg']"
                                @input="setImage"
                                
                                
                            ></image-uploader>
                        </div>
                    </div>
                    <div class="row">
                        <small class="d-block text-uppercase font-weight-bold mb-3">Vista previa</small>
                        <div class="form-group input-group">
                            <p v-if="!hasImage">No se ha seleccionado ninguna foto...</p>
                            <img :src="previewImageSrc"
                                    class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                    style="width: 200px;">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 col-lg-12 mb-5 mb-lg-0">
                            <div class="px-12">
                                
                            </div>
                        </div>
                    </div>
                    <!--
                    <div class="row justify-content-center">
                        <div class="card-profile-image">
                            <img style="max-height: 200px;" class="rounded-circle" :src="previewImageSrc">
                        </div>
                    </div>
                    -->
                    <div class="text-center">
                         <base-button @click="showModal = false" type="white" class="my-4">Cancelar</base-button>
                        <base-button :disabled="!hasImage" type="primary" class="my-4" @click="subirFoto">Subir foto</base-button>
                    </div>
                </form>
            </template>
        </card>
    </modal>
</template>

<script>
export default {
    name: 'CambiarImagenPerfil',
    data(){
        return {
            showModal: false,
            hasImage: false,
            previewImageSrc: '',
            imageOutput: Object
        }
    },
    created(){
        this.$parent.$on('abrirModalCambiarImagen', () => {this.showModal = true} );
    },
    methods: {
        setImage: function(output) {
            this.hasImage = true
            console.log(output)
            this.previewImageSrc = output.dataUrl;
            this.imageOutput = output;
        },
        subirFoto(){
            console.log(this.imageOutput);
            let vm = this;
            let bodyFormData = new FormData();
            bodyFormData.set('imagen', this.imageOutput.dataUrl);

            this.axios({
                method: 'POST',
                data: bodyFormData,
                url: 'api/user_photo',
                headers: {
                    'Content-type': 'multipart/form-data'
                }
            }).then(function(){
                vm.$store.dispatch("retrieveUser").then( response => {
                    vm.$notify({
                        type: 'success',
                        message: 'Imagen de perfil actualizada correctamente'
                    });
                    vm.showModal = false;
                });
            }).catch(function(error){
                console.log(error);
                vm.$notify({
                    type: 'danger',
                    message: 'No se pudo actualizar la información del usuario. Intentelo de nuevo mas tarde.'
                }); 
            });
        }
    }
}
</script>